// extracted by mini-css-extract-plugin
export default {"frame":"IframePop_frame__XWjZ0","animate-rotate":"IframePop_animate-rotate__ceiFZ"};